import { buildAtlAttributionHeaders } from '@atlassian/search-client/atl-attribution';
import { fetchJiraFieldsQuery } from '@atlassian/search-client/hydration';

import type { PrimaryProductKey } from '../../../common/constants/products';

import type { JiraIssueStatusAndColorName } from './search-result/search-result-renderer/search-jira-issue';

export const fetchAndUpdateJiraFields = async (
	cloudId: string | undefined,
	issueKeys: string[],
	aggAbsoluteUrl: string | undefined,
	setJiraStatuses: React.Dispatch<
		React.SetStateAction<Record<string, JiraIssueStatusAndColorName | null>>
	>,
	logError: (error: unknown) => void,
	activationId?: string,
	product?: PrimaryProductKey,
): Promise<void> => {
	if (cloudId && issueKeys.length > 0) {
		try {
			const headers = buildAtlAttributionHeaders({
				cloudId,
				activationId,
				product,
			});
			const response = await fetchJiraFieldsQuery({
				variables: {
					issueKeys,
					cloudId,
				},
				aggAbsoluteUrl,
				headers,
			});
			const issuesByKey = response.data?.jira?.issuesByKey;
			setJiraStatuses((prevIssueStatuses) => {
				if (issuesByKey) {
					const issueStatuses: Record<string, JiraIssueStatusAndColorName | null> = {
						...prevIssueStatuses,
					};
					// Have seen the issuesByKey have [null] responses
					for (const issue of issuesByKey.filter((issue) => issue)) {
						const statusName = issue.statusField?.status?.name;
						const colorName = issue.statusField?.status?.statusCategory?.colorName;
						const statusCategoryId = issue.statusField?.status?.statusCategory?.statusCategoryId;
						if (issue.id && statusName && colorName) {
							issueStatuses[issue.id] = {
								statusName,
								colorName,
								statusCategoryId,
							};
						}
					}
					return issueStatuses;
				}
				return prevIssueStatuses;
			});
			return;
		} catch (e) {
			logError(e);
		}
	}
	// If fetching Jira fields fails, we still want to update the issue statuses to null
	setJiraStatuses((prevIssueStatuses) => {
		const issueStatuses: Record<string, JiraIssueStatusAndColorName | null> = {
			...prevIssueStatuses,
		};
		for (const key of issueKeys) {
			issueStatuses[key] = null;
		}
		return issueStatuses;
	});
};
